import * as type from '../actions/types';

const initialState = {
  pending: false,
  error: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.SAVE_RESTAURANT_PAUSE_PENDING:
      return {
        ...state,
        pending: true,
        error: '',
      };
    case type.SAVE_RESTAURANT_PAUSE_SUCCESS:
      return {
        ...state,
        pending: false,
        success: true,
      };
    case type.SAVE_RESTAURANT_PAUSE_FAILURE:
      return {
        ...state,
        error: action.payload,
        pending: false,
      };

    case type.REACTIVATE_RESTAURANT_PAUSE_PENDING:
      return {
        ...state,
        pending: true,
        error: '',
      };
    case type.REACTIVATE_RESTAURANT_PAUSE_SUCCESS:
      return {
        ...state,
        pending: false,
        success: true,
      };
    case type.REACTIVATE_RESTAURANT_PAUSE_FAILURE:
      return {
        ...state,
        error: action.payload,
        pending: false,
      };

    default:
      return state;
  }
};
